export const RESET = 'INFO_LIST_RESET';
export const SET_ITEMS = 'INFO_LIST_SET_ITEMS';
export const SET_ERROR = 'INFO_LIST_SET_ERROR';
export const SET_SELECT_ITEMS = 'INFO_LIST_SET_SELECT_ITEMS';
export const SET_VIEW = 'INFO_LIST_SET_VIEW';
export const TOGGLE_LOADING = 'INFO_LIST_TOGGLE_LOADING';



// WEBPACK FOOTER //
// ./src/store/modules/info/list/mutation_types.js